import * as React from "react";

function HeroHeading() {
  return (
    <h1 className="mb-6 text-6xl font-bold leading-tight text-white max-md:text-5xl max-sm:text-4xl">
      Peek under the hood.
    </h1>
  );
}

export default HeroHeading;
